import api from '@/utils/axios';
import { unwrapItem } from '@/utils/apiHelpers';
import type { LandingDynamicData, PublicTrackingData } from './types';

export async function fetchLandingData(): Promise<LandingDynamicData> {
  const res = await api.get('/public/landing');
  return unwrapItem<LandingDynamicData>(res.data);
}

export async function fetchPublicTracking(code: string): Promise<PublicTrackingData> {
  const res = await api.get(`/public/tracking/${encodeURIComponent(code.trim())}`);
  return unwrapItem<PublicTrackingData>(res.data);
}
